import { createMetaDef } from '@exodus/asset'

import tokensParams from './tokens.js'

const name = 'avalanchec'
const displayName = 'Avalanche'
const ticker = 'AVAXC'
const displayTicker = 'AVAX'
const displayNetworkTicker = 'AVAXC'
const displayNetworkName = 'Avalanche C-Chain'
const primaryColor = '#FE7C7D'
const gradientColors = ['#E84142', '#FE7C7D']
const gradientCoords = { x1: '-3.98%', y1: '1.381%', x2: '49.273%', y2: '30.414%' }
const chainBadgeColors = gradientColors
const chainId = 43_114

const gasLimit = 21_000 // enough to send AVAX-C for Transfer type
const contractGasLimit = 1e6 // used when estimateGas fails

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  nAVAX: 9,
  szabo: 12,
  finney: 15,
  [ticker]: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'AVAX_ERC20'
const blockExplorer = {
  addressUrl: (accountId) =>
    `https://cchain.explorer.avax.network/address/${encodeURIComponent(accountId)}`,
  txUrl: (txId) => `https://cchain.explorer.avax.network/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Avalanche is an open-source platform for launching decentralized finance applications and enterprise blockchain deployments in one interoperable, highly scalable ecosystem. It is a smart contract-capable blockchain platform focused on transaction speed, low costs, and eco-friendliness.',
  reddit: 'https://www.reddit.com/r/Avax',
  twitter: 'https://twitter.com/AvalancheAVAX',
  website: 'https://www.avax.network/',
  telegram: 'https://t.me/avalancheavax',
  medium: 'https://medium.com/avalancheavax',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

const tokenOverrides = (token) => ({
  ...token,
  contract: token.addresses,
  gasLimit: 120e3,
})

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
  tokensParams,
  tokenOverrides,
})

// obsolete
export const avalanchec = asset

export default assetsList
